import styled from '@emotion/styled';
import { Typography, tokens } from '@galaxy-react/core';

export const PreviousSearchResultStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  padding: '8px',
  paddingTop: 0,
  flex: 1,
});

export const Subheading = styled(Typography)({
  padding: 8,
});

export const RecentSearchStyled = styled('a')({
  display: 'flex',
  gap: 8,
  padding: 8,
  color: tokens.colorNeutralForeground1,
  alignItems: 'center',
  borderRadius: tokens.borderRadiusMedium,
  '&:hover': {
    backgroundColor: '#1C365F0A',
  },
  userSelect: 'none',
});

export const SearchListBoxStyled = styled('div')({
  overflow: 'hidden',
  padding: 0,
  paddingBottom: 12,
  margin: '4px 0px 0px -4px',
  height: '100%',
});

export const SearchListBoxPanelWrapperStyled = styled('div')({
  width: '100%',
  height: '320px',
  display: 'flex',
  gap: tokens.spacingHorizontalM,
});

export const SearchListBoxPanelOverflowStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'panelVisible',
})<{ panelVisible?: boolean }>(({ panelVisible }) => ({
  flex: 1,
  flexBasis: panelVisible ? '62%' : '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  maxHeight: '320px',
  padding: `${tokens.spacingHorizontalNone} ${tokens.spacingVerticalXXS}`,
  transition: 'flex-basis 0.3s ease',
}));

export const SearchListBoxPanelPreviewStyled = styled('div')({
  flexBasis: '38%',
  height: '100%',
  marginRight: '8px',
});
